import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function EyeIcon({
	width = 22,
	height,
	color = 'currentColor',
	opacity,
	style,
	...rest
}: IconRenderProps): ReactElement {
	const h = height ?? Math.round((width ?? 22) * (17 / 22));
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={h}
			viewBox="0 0 22 17"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', opacity, ...style }}
			{...rest}
		>
			<path
				d="M10.7617 0.25C15.5509 0.250037 19.7327 3.34479 21.168 7.9502L21.2617 8.25L21.168 8.5498C19.7328 13.1548 15.5509 16.25 10.7617 16.25C5.97246 16.25 1.79072 13.1552 0.354492 8.5498L0.261719 8.25L0.354492 7.9502C1.79068 3.34416 5.97246 0.25 10.7617 0.25ZM10.7617 2.25C6.94855 2.25 3.60438 4.64782 2.3457 8.25C3.6044 11.853 6.94855 14.25 10.7617 14.25C14.5758 14.25 17.92 11.853 19.1777 8.25C17.92 4.64805 14.5756 2.25004 10.7617 2.25ZM10.7617 4.24902C12.9491 4.24907 14.7285 6.0439 14.7285 8.25C14.7285 10.4561 12.9491 12.2509 10.7617 12.251C8.5743 12.251 6.79492 10.4561 6.79492 8.25C6.79492 6.04387 8.57432 4.24902 10.7617 4.24902ZM10.7617 6.25C9.66852 6.25 8.7793 7.1465 8.7793 8.25C8.77934 9.35252 9.66761 10.25 10.7617 10.25C11.8558 10.25 12.7441 9.35343 12.7441 8.25C12.7441 7.14747 11.8558 6.25005 10.7617 6.25Z"
				fill={color}
			/>
		</svg>
	);
}
